const RepeatIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 15 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M1 3L3 1M3 1L5 3M3 1V7.66667C3 8.02029 3.14048 8.35943 3.39052 8.60948C3.64057 8.85952 3.97971 9 4.33333 9H8.33333M14.3333 7L12.3333 9M12.3333 9L10.3333 7M12.3333 9V2.33333C12.3333 1.97971 12.1929 1.64057 11.9428 1.39052C11.6928 1.14048 11.3536 1 11 1H7"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default RepeatIcon;
